import cacheAngularTemplate from 'cacheAngularTemplate';
import { DisconnectedError } from 'DisconnectedError';
import orderBy from 'Utils/orderBy';
import groupBy from 'Utils/groupBy';
import keyBy from 'Utils/keyBy';
import { targetBrandConfig } from 'AppBranding';
import { getRelevantCohorts } from 'Users';
import { modifyHref } from 'NavigationHelpers';
import template from '../../views/stream/stream_dashboard_external_links.html';
import angularModule from '../lessons_module';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('streamDashboardExternalLinks', [
    '$injector',
    function factory($injector) {
        const $rootScope = $injector.get('$rootScope');
        const ExternalLinkMetadatum = $injector.get('ExternalLinkMetadatum');
        const NavigationHelperMixin = $injector.get('Navigation.NavigationHelperMixin');
        const EventLogger = $injector.get('EventLogger');
        const isMobileMixin = $injector.get('isMobileMixin');

        return {
            scope: {
                stream: '<',
            },
            restrict: 'E',
            templateUrl,
            controllerAs: 'controller',
            link(scope) {
                //---------------------------
                // Initialization
                //---------------------------

                NavigationHelperMixin.onLink(scope);
                isMobileMixin.onLink(scope);

                scope.lessonsById = keyBy(scope.stream.lessons, 'id');
                scope.recordsForStream = [];
                scope.institutionBrandName = targetBrandConfig($rootScope.currentUser).brandNameShort;

                //---------------------------
                // Data Loading
                //---------------------------

                ExternalLinkMetadatum.getAllForStream(
                    scope.stream.id,

                    // Use all the user's cohorts, since a user can view streams that are not attached to their
                    // active cohort
                    getRelevantCohorts($rootScope.currentUser).map(c => c.id),
                    {
                        'FrontRoyal.ApiErrorHandler': { background: true },
                    },
                )
                    .then(
                        records => {
                            scope.recordsForStream = orderBy(
                                records.filter(record => record.isWorking),
                                ['required', 'sort'],
                                ['desc', 'asc'],
                            );

                            // modify any uploads.smart.ly urls to uploads.quantic.edu
                            scope.recordsForStream.forEach(record => {
                                record.url = modifyHref(record.url);
                            });

                            scope.recordsByLessonId = groupBy(scope.recordsForStream, 'lesson_id');
                        },
                        () => {
                            // no-op
                        },
                    )
                    .catch(err => {
                        if (err.constructor !== DisconnectedError) {
                            throw err;
                        }
                    });

                //---------------------------
                // Functions
                //---------------------------

                scope.openExternalLink = ($event, url) => {
                    $event.preventDefault(); // don't follow href attribute, which is only there for a11y
                    EventLogger.log('stream_dashboard_external_links:clicked_external_link', { link: url });
                    scope.loadUrl(url, '_blank');
                };

                scope.setExpanded = shouldExpand => {
                    scope.isExpanded = shouldExpand;
                };

                //---------------------------
                // Watchers
                //---------------------------

                scope.$watch('isMobile', isMobile => {
                    scope.isExpanded = !isMobile;
                });
            },
        };
    },
]);
